// Username клиента: ник латиницей из адреса доставки (те же правила, что на сервере)
export const USERNAME_HINT = 'Код клиента латиницей (3–30 символов: буквы, цифры, _ . -), как в адресе доставки';

const USERNAME_RE = /^[A-Za-z0-9][A-Za-z0-9_.-]{2,29}$/;

// Возвращает текст ошибки или пустую строку, если ник корректен
export const validateUsername = (value) => {
    const username = String(value ?? '').trim();
    return USERNAME_RE.test(username) ? '' : USERNAME_HINT;
};
